export default "__VITE_ASSET__UN2cQDhy__"